export const PARNASSUS_HOST =
  process.env["NEXT_PUBLIC_PARNASSUS_URL"] || "/parnassus/api/v2";

export type FlexDirection =
  | "column"
  | "inherit"
  | "-moz-initial"
  | "initial"
  | "revert"
  | "unset"
  | "column-reverse"
  | "row"
  | "row-reverse"
  | undefined;
export type Overflow =
  | "visible"
  | "hidden"
  | "clip"
  | "scroll"
  | "auto"
  | undefined;
